import axios from "axios";

let API_URL: string = "/";
let DEV_TOKEN: string = "";

if (typeof process !== "undefined") {
  API_URL = process.env.REACT_APP_EASAS_API!;
  DEV_TOKEN = process.env.REACT_APP_DEV_TOKEN!;
}

function createAxiosClient() {
  let withCredentials = false;
  const headers: any = {
    "Content-type": "application/json",
  };

  if (typeof process !== "undefined") {
    headers["Authorization"] = `Bearer ${DEV_TOKEN}`;
  } else {
    withCredentials = true;
  }

  const axiosInstance = axios.create({
    baseURL: API_URL,
    headers: headers,
    withCredentials: withCredentials,
  });

  //const retryInterceptor = require("axios-retry-interceptor");
  //retryInterceptor(axiosInstance, { maxAttempts: 10, waitTime: 100 });

  return axiosInstance;
}

const axiosClient = createAxiosClient();

export default axiosClient;
